import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Modal } from 'antd';
import { useState, useEffect } from 'react';
import { useAppDispatch } from '../../methods/redux/hooks';
import { registerInvestment } from '../../methods/redux/reducers/investment';

// Styled component
const UnregisteredInvestmentProfileStyle = styled.div`
	padding: 15px;
	background-color: #f8f8f8;
	margin-bottom: 10px;

	.title {
		font-size: 18px;
		text-transform: capitalize;
	}

	.details {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
		border-top: 1px dashed #ccc;
		margin-top: 10px;

		> div {
			min-width: 50px;
			margin-right: 15px;
			padding: 5px 0;
			font-size: 13px;

			.label {
				color: #bbb;
				font-size: 12px;
			}
		}
	}
`;

// Interface for Investment Profile
interface InvestmentProfile {
	_id: string;
	email: string;
	fullName: string;
	isRobot: boolean;
	username: string;
}

interface IUnregisteredInvestment {
	investmentProfile: InvestmentProfile;
}

const UnregisteredInvestmentList = ({
	investmentProfile,
}: IUnregisteredInvestment) => {
	const dispatch = useAppDispatch(); // ✅ Moved inside the component
	const [visible, setVisible] = useState(false);
	const [state, setState] = useState({
		// bvn: '',
		// memberId: '',
		investmentId: investmentProfile?._id,
	});

	const submit = () => {
		dispatch(registerInvestment({ ...state }));
		setVisible(false);
	};
	useEffect(() => {
		setState((prev) => ({
			...prev,
			// memberId: investmentProfile._id,
			investmentId: investmentProfile._id,
		}));
	}, [investmentProfile._id]);

	return (
		<UnregisteredInvestmentProfileStyle>
			<div>
				<Link
					to={`/core-modules/investment/${investmentProfile._id || ''}`}
					className="title"
				>
					{investmentProfile.fullName || 'Full Name'}
				</Link>
			</div>

			<div className="details">
				<div>
					<p>{investmentProfile.username || 'Username'}</p>
					<p className="label">Username</p>
				</div>

				<div>
					<p>{investmentProfile.email || 'Email'}</p>
					<p className="label">Email</p>
				</div>

				<div>
					<p>{investmentProfile.isRobot ? 'true' : 'false'}</p>{' '}
					{/* ✅ Fix boolean display */}
					<p className="label">Is Robot</p>
				</div>
				{/* <div>
					<Button type="primary" onClick={() => setVisible(true)}>
						Retry Investment
					</Button>
				</div> */}
			</div>

			<Modal
				okText="Confirm"
				title="Retry Investment"
				onOk={submit}
				open={visible} // ✅ Fix deprecated `visible` prop
				onCancel={() => setVisible(false)}
			>
				{/* <p>Bvn Number</p>
				<Input
					value={state.bvn}
					onChange={(e) => setState({ ...state, bvn: e.target.value })}
				/> */}
				<p>Are you sure you want to retry this investment?</p>
			</Modal>
		</UnregisteredInvestmentProfileStyle>
	);
};

export default UnregisteredInvestmentList;
